import { GlBadge } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import Tracking from '../../../../../../../app/assets/javascripts/tracking/index.js?vue3';
import TierBadgePopover from './tier_badge_popover.vue?vue3';
export default {
    name: 'TierBadge',
    components: {
        GlBadge,
        TierBadgePopover
    },
    mixins: [
        Tracking.mixin({
            label: 'tier_badge'
        })
    ],
    props: {
        tier: {
            type: String,
            required: false,
            default: s__('TierBadge|Free')
        }
    },
    data: ()=>({
            target: undefined
        }),
    mounted () {
        this.trackRender();
        this.target = this.$refs.badge?.$el;
    },
    methods: {
        trackRender () {
            this.track('render_badge');
        },
        trackHover () {
            this.track('render_flyout');
        }
    }
};
